export default {
    userInfo: {
        firstName: '',
        email: '',
        lastName: '',
        phone: '',
        company: '',
        line1: '',
        city: '',
        state: '',
        postalCode: '',
        currency: window.constants.currencies.USD,
        // `country` is the phone field's country guess (rewritten on every keystroke);
        // the billing address keeps its own value so editing the phone never changes it.
        country: 'US',
        billingCountry: '',
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone || '',
        userId: '',
        jwt: '',
    },
    purchaseInfo: {
        partnerAccountId: '',
        linkPostedBy: '',
        bundleId: '',
        sourceCode: '',
        partnerName: '',
        flow: '',
        linkId: '',
    },
    talon: '{\'version\': 6, \'status\': -1}',
    orderStatus: {
        submitting: false,
        success: false,
    },
    returningCustomer: {
        hasActiveFreeTrial: false,
        appId: '',
        token: '',
    },
    error: {
        active: false,
        message: '',
        code: 0,
    },
    redirectLocation: '',
    provisioningId: '',
    canSubmit: false,
    instantOn: false,
    tracking: {},
    loading: false,
    recaptchaToken: '',
    testBox: false,
    transactionId: '',
    // Raw `{ slug, active }` list from /api/v1/system/feature-flags; read via the `featureFlags` getter.
    flags: [],
};
